// extracted by mini-css-extract-plugin
export var header = "_ib-0";